import { UserBar } from "@layout/UserBar";
import { UsersList } from "@layout/UserList";

import { Stack } from "@components/Stack";

import { useLayoutBreakpoint } from "@hooks/useLayoutBreakpoint";

import { cn } from "@lib/utils";

import { BroadcastControlBar } from "./BroadcastControlBar";
import { BroadcastStatusBar } from "./BroadcastStatusBar";
import { BroadcastTimer } from "./BroadcastTimer";
import { LogoMobile } from "./LogoMobile";
import { ToggleSound } from "./ToggleSound";

export const Topbar = () => {
	const { DESKTOP, MAX_DESKTOP, MOBILE, TABLET } = useLayoutBreakpoint();

	const isDesktop = DESKTOP || MAX_DESKTOP;
	const isMobile = MOBILE || TABLET;

	return (
		<Stack direction={isMobile ? "column" : "row"} wide>
			<Stack direction="row" justify="between" align="center" wide className={cn(isMobile ? "mb-4" : "")}>
				{MOBILE ? <LogoMobile /> : null}

				<Stack direction="row" spacing={isMobile ? 8 : 0}>
					<BroadcastStatusBar />
					<ToggleSound />
				</Stack>
				<Stack direction="row" align="center" spacing={MAX_DESKTOP ? 32 : 2}>
					{isDesktop ? <BroadcastControlBar /> : null}
				</Stack>

				{isDesktop ? <BroadcastTimer /> : null}

				{isMobile ? <UserBar /> : null}
			</Stack>

			{isMobile ? (
				<Stack spacing={16} wide>
					<BroadcastControlBar />
					<UsersList />
				</Stack>
			) : null}
		</Stack>
	);
};
